/**
 * Professions Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import AppConfig from "../../../constants/AppConfig";

// States
const state = {
    todoList: [],
    todoItem: {},
};

// Getters
const getters = {
    todoList: state => {
        return state.todoList
    },

    todoItem: state => {
        return state.todoItem
    },
};

// Actions
const actions = {
    getTodoList(context, payload) {
        function successCallback(response) {
            context.commit('getTodoListHandler', { todoList: response.data.suivis });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.TodoList.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getTodoItem(context, payload) {
        function successCallback(response) {
            context.commit('getTodoItemHandler', { todoItem: response.data.suivi });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.TodoList.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createTodoItem(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // Here we add a follow-up to the list of follow-ups
            context.commit('pushTodoListHandler', { todoItem: response.data.toDo });

            // we can leave to the route of a tracking display
            // We assume that if there's a view to display a tracker or followed-up, that we call it suivi
            // router.push({ name: 'suivi', params: { suivi: response.data.suivi.slug } });
            // router.push({ name: 'follow-up' });
            // router.push({ name: 'follow-up-category', params: {followUpCategorySlug: payload.slugToRedirect} });
            payload.refreshArray(response.data.toDo, payload.args.listable_id);
        }


        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.TodoList.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateTodoItem(context, payload) {
        function successCallback(response) {

            if (payload.shouldSentNotification) {
                Vue.swal(
                    payload.successMessage,
                    '',
                    'success'
                );
            }
            // console.log('refreshArray successCallback');
            payload.refreshArray(response.data.toDo, payload.args.listable_id);

            // store.dispatch('findAndRemove', {name: 'suivi' });

            //We assume that if there's a view to display a tracker
            //or followed-up, that we call it suivi

            // router.push({ name: 'follow-up-category', params: {followUpCategorySlug: payload.args.slugToRedirect} });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.TodoList.Create.url + '/' + payload.slug;

        Vue.axios.put(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then(successCallback)
        .catch(errorCallback);

        //makeApiRequest(payload.args, apiModel.Followed.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteTodoItem(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            // payload.refreshArray(response.data.toDo, payload.args.listable_id);
            // context.commit('deleteTodoItemHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        const url = AppConfig.apiUrl + apiModel.TodoList.Create.url + '/' + payload.slug;

        Vue.axios.delete(
            url,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    // 'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then(successCallback)
        .catch(errorCallback);

        // makeApiRequest(payload.args, apiModel.Followed.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getTodoListHandler(state, { todoList }) {
        // Update followed state
        state.todoList = todoList;
    },

    pushTodoListHandler(state, { todoItem }) {
        // Update followed state
        state.todoList .push(todoItem);
    },

    getTodoItemHandler(state, { todoItem }) {
        // Update followUp state
        state.todoItem = todoItem;
    },

    deleteTodoItemHandler(state, { index, successMessage }) {
        let i = state.todoList.findIndex(followUp => followUp.slug === index);

        if (~i) {
            state.todoList.splice(i, 1);

            // After deleting from the list of follow-ups you can go to the listing route
            // if you wish. Please note that if we are on the follow-ups listing page,
            // the list of follow-ups is already updated as of this date.

            //We assume that if there is a view to display the
            // follow-ups, that we call it follow-ups
            // router.push({ name: 'suivis' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    },

    deleteSpecialtyFollowUpHandler(state, { index, successMessage }) {
        if( state.followUp.hasOwnProperty('specialites'))
        {
            let i = state.followUp.specialites.findIndex(followUp => followUp.slug === index);
            if (~i) {
                state.followUp.specialites.splice(i, 1);
            }
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
